import Clickable from 'components/Common/Clickable'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import type { ComponentProps, MouseEventHandler } from 'react'
import React, { useCallback } from 'react'
import _PriceRowLoyaltyPointsContent from './_PriceRowLoyaltyPointsContent'
import { LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL } from 'loyalty/constants/loyaltyBonusPoints'

interface Props extends ComponentProps<typeof _PriceRowLoyaltyPointsContent> {
  tier: App.LoyaltyTier
  campaigns: Array<App.LoyaltyBonusPointsCampaignType>
  size: 'S' | 'M'
  /**
   * @default start
   */
  horizontalAlign?: 'start' | 'center'
  onPillClick?: MouseEventHandler<HTMLButtonElement>
}

export const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyText>['variant']> = {
  S: 'small',
  M: 'medium',
}

const TIER_BODY_TEXT_COLOURS: Record<App.LoyaltyTier, App.Design.ContentColour> = {
  bronze: 'tier-bronze-dark',
  silver: 'tier-silver-dark',
  gold: 'tier-gold-dark',
  platinum: 'tier-platinum',
}

function PriceRowLoyaltyPointsPromoPill({
  tier,
  size,
  campaigns,
  earnablePoints,
  statusCredits,
  calculationType,
  pointsEarnRatio,
  horizontalAlign = 'start',
  trailingCaption,
  onInfoIconClick,
  onPillClick,
}: Props) {
  const handlePillClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onPillClick?.(event)
  }, [onPillClick])

  return <Group
    direction="horizontal"
    horizontalAlign={horizontalAlign}
    verticalAlign="center"
    wrap="wrap"
    // @ts-expect-error 6 isn't allowed. Temporary fix until design properly addresses this.
    gap="6 8"
  >
    {campaigns.map(campaign => (
      <Clickable key={campaign} onClick={onPillClick ? handlePillClick : undefined}>
        <LoyaltyTierPill kind="primary" tier={tier}>{LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL[campaign]}</LoyaltyTierPill>
      </Clickable>
    ))}
    <BodyText variant={SIZES_BODY_TEXT_VARIANTS[size]} weight="bold" colour={TIER_BODY_TEXT_COLOURS[tier]}>
      <_PriceRowLoyaltyPointsContent
        earnablePoints={earnablePoints}
        pointsEarnRatio={pointsEarnRatio}
        statusCredits={statusCredits}
        onInfoIconClick={onInfoIconClick}
        trailingCaption={trailingCaption}
        calculationType={calculationType}
      />
    </BodyText>
  </Group>
}

export default PriceRowLoyaltyPointsPromoPill
